import account from "./account";
import device from "./device";
import devices from "./devices";
import requests from "./requests";

export default {
  state: {},
  namespaced: true,
  modules: {
    account,
    device,
    devices,
    requests,
  },
};
